module.exports = __webpack_public_path__ + "static/media/md-partly-sunny.018889cc.svg";